import * as React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { withRouter, RouteComponentProps } from 'react-router';
import { css, StyleSheet } from 'aphrodite';
import { IState } from '../../../reducers/index';

import Loading from '../../../components/Loading';
import FrequentQuestions from '../../../components/landingpagenew/FrequentQuestions';
import Reviews from '../../../components/landingpagenew/Reviews';
import FinalCreateAccount from '../../../components/landingpagenew/FinalCreateAccount';
import LandingPageNewTopSection from '../../../components/landingpagenew/LandingPageNewTopSection';
import UseCases from '../../../components/landingpagenew/UseCases';
import StartListeningBanner from '../../../components/landingpagenew/StartListeningBanner';
import LandingPageNewNavbar from '../../../components/landingpagenew/LandingPageNewNavbar';
// import LandingPagePublishers from '../../../components/landingpagenew/LandingPagePublishers';
import SeriesExplainer from '../../../components/landingpagenew/SeriesExplainer';
import LandingEditorialInsights from '../../../components/landingpagenew/LandingEditorialInsights';
import newtheme from '../../../newtheme';
import IUser from '../../../types/models/IUser';
import { getQueryString } from '../../../utils/url';
import LoadingPage from '../../../components/LoadingPage';
import { openModal } from '../../../actions/modal';
import ModalTypes from '../../../types/ModalTypes';
import { ILandingPageHero } from '../types/ILandingPageHero';
import Ratings from '../../../components/landingpagenew/Ratings';
import LandingPageNewSitemap from '../../../components/landingpagenew/LandingPageNewSitemap';
import ISubscriptionProduct from '../../subscribe/types/ISubscriptionProduct';
import { getSelectedSubscriptionProduct } from '../../subscribe/state/selectors';
import LandingPagePublishers from '../../../components/landingpagenew/LandingPagePublishers';
import ErrorMessage from '../../../components/ErrorMessage';
import { getFaqQuestionsByIds } from '../../faq/faqdata';
import { mpTrackButtonClick } from '../../../tracking/mixpanel';
import { MpTrackingButtons } from '../../../config/buttons';
import config from '../../../config';

interface IPropsFromState {
    loading: boolean;
    serverLoaded: boolean;
    user?: IUser;
    subscriptionProduct?: ISubscriptionProduct;
}

interface IPropsFromDispatch {
    openModal: typeof openModal;
}

class LandingPageNew extends React.Component<IPropsFromState & IPropsFromDispatch & RouteComponentProps> {
    public isGo1 = () => {
        const { location } = this.props;

        const queries = getQueryString(location.search);

        return queries.utm_source === 'go1';
    };

    public onSignUpFaqButtonClicked = () => {
        const { subscriptionProduct } = this.props;

        if (
            subscriptionProduct &&
            subscriptionProduct.metadata.homePage &&
            subscriptionProduct.metadata.homePage.redirectToPage
        ) {
            if (this.props.user || !subscriptionProduct.metadata.homePage.showSignup) {
                this.props.history.push(subscriptionProduct.metadata.homePage.redirectToPage);
                return;
            }

            this.showSignup();
            return;
        }

        if (this.props.user) {
            this.props.history.push(config.routes.homeWebPlayer);
            return;
        }

        this.showSignup();
    };

    public showSignup = () => {
        mpTrackButtonClick(MpTrackingButtons.SHOW_SIGNUP_FAQ);

        this.props.openModal(ModalTypes.SignUpNew);
    };

    public render() {
        const { loading, subscriptionProduct } = this.props;

        if (loading) {
            return <LoadingPage isDark />;
        }

        if (!subscriptionProduct || !subscriptionProduct.metadata.homePage.components) {
            return <ErrorMessage message="Offer not found" />;
        }

        const { components: landingPage } = subscriptionProduct.metadata.homePage;

        return (
            <div className={css(styles.main)}>
                <Loading loading={loading} />
                <LandingPageNewNavbar
                    enableTransparentMode={
                        !!(
                            (landingPage.find((section) => section.type === 'HERO') as ILandingPageHero)?.style ===
                            'MOBILE_FIRST'
                        )
                    }
                />

                {landingPage.map((section) => {
                    switch (section.type) {
                        case 'HERO':
                            return <LandingPageNewTopSection sectionData={section} isGo1={this.isGo1()} />;
                        case 'PUBLISHERS':
                            return (
                                <LandingPagePublishers
                                    heading={`One app.
Multiple perspectives`}
                                />
                            );
                        case 'SERIES_CAROUSEL':
                            return <SeriesExplainer sectionData={section} />;
                        case 'DOWNLOAD_APP':
                            return <Ratings />;
                        case 'USE_CASES':
                            return <UseCases sectionData={section} />;
                        case 'FAQS':
                            return (
                                <FrequentQuestions
                                    questions={getFaqQuestionsByIds(section.ids)}
                                    mode="STANDARD"
                                    onSignupClicked={this.onSignUpFaqButtonClicked}
                                />
                            );
                        case 'CONTENT_USP':
                            return <LandingEditorialInsights sectionData={section} />;
                        case 'SIGNUP_BLOCK_1':
                            return <StartListeningBanner sectionData={section} />;
                        case 'APP_REVIEWS':
                            return <Reviews />;
                        case 'SIGNUP_BLOCK_2':
                            return <FinalCreateAccount sectionData={section} />;
                        default:
                            return null;
                    }
                })}

                <LandingPageNewSitemap />
            </div>
        );
    }
}

// To make initial loading look better
const styles = StyleSheet.create({
    main: {
        minHeight: 1200,
        position: 'relative',
        backgroundColor: '#031629',
        color: 'white',
    },
    spacer: {
        [newtheme.cssBreakpoints.tiny]: {
            display: 'none',
        },
        height: 75,
        backgroundColor: 'white',
    },
});

function mapStateToProps(state: IState): IPropsFromState {
    return {
        loading: state.recommendation.loading || state.subscription.loading,
        serverLoaded: state.app.serverLoaded,
        user: state.user.user,
        subscriptionProduct: getSelectedSubscriptionProduct(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch): IPropsFromDispatch {
    return bindActionCreators(
        {
            openModal,
        },
        dispatch,
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LandingPageNew));
